// extracted by mini-css-extract-plugin
export var content = "style-module--content--drU6N";
export var darkhowitworks = "style-module--darkhowitworks--InP6d";
export var darkhowitworksbtn = "style-module--darkhowitworksbtn--8h5KI";
export var darktitle = "style-module--darktitle--u7Foj";
export var descrcopy = "style-module--descrcopy--yl8h9";
export var descricon = "style-module--descricon--+R5Vs";
export var descritem = "style-module--descritem--bumm5";
export var descrs = "style-module--descrs--X35AF";
export var descrtitle = "style-module--descrtitle--bu9tt";
export var howitworks = "style-module--howitworks--lPZWD";
export var icon = "style-module--icon--MJ+zk";
export var step = "style-module--step--GW+pB";
export var steps = "style-module--steps--UbQ+k";
export var title = "style-module--title--TlT7J";